<form [formGroup]="swPartNumberForm">
  <div class="space-y-12">
    <div class="border-b border-gray-900/10 pb-6">
      <p class="mt-1 text-sm/6 text-gray-600">You can edit the SW-Part-Number here.</p>

      <div class="grid gap-6 mt-6">
        <div class="col-span-full border-t border-gray-900/10 pt-4">
          <app-text-area
            [fieldConfigurationAddress]="'swpartnumber.internalNotes'"
            [label]="'Internal notes'"
            [formControl]="internalNotes"
            [fieldIsRequired]="false"
            [displayChangeIndicator]="false"
          ></app-text-area>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-6 flex items-center justify-end gap-x-6">
    <button
      type="button"
      [disabled]="swPartNumberForm.invalid"
      (click)="update()"
      class="crud-btn-sidebar"
      appAgentAction
      agent="edit-sw-part-number-save"
      businessObject="swPartNumber"
      [businessId]="$safeNavigationMigration(swPartNumber?.id)"
      action="save"
    >
      <app-floppy-icon></app-floppy-icon>
    </button>
  </div>
</form>
